export default "__VITE_ASSET__BVPzalsE__"